export default class Context {

    constructor(id, name, language){
        this.id = id;
        this.name = name;       
        this.sections = [];
        this.language = language;
    }

    getId(){
        return this.id;
    }

    getName(){
        return this.name;
    }

    getSections(){
        return this.sections;
    }

    getLanguage(){
        return this.language;
    }

    setId(id){
        this.id = id;
    }

    setName(name){
        this.name = name;
    }

    setSections(sections){
        this.sections = sections;
    }

    setLanguage(language){
        this.language = language;
    }
}